export const orphan = {
  beforeMount(el) {
    el.innerHTML = el.innerHTML.trim().replace(/\s([^\s]*)$/, "&nbsp;" + "$1");
  }
};
